import { MutationTree } from 'vuex';
import { LoginStateInterface } from './state';

const mutation: MutationTree<LoginStateInterface> = {
  setAuthenticated(state: LoginStateInterface): void {
    state.authenticated = true;
  },
  setUnAuthenticated(state: LoginStateInterface): void {
    state.authenticated = false;
  },
  setAttributes(state: LoginStateInterface, payload: { email?: string; role?: string; organizationId?: string }): void {
    state.email = typeof payload.email !== 'undefined' ? payload.email : '';
    state.role = typeof payload.role !== 'undefined' ? payload.role : '';
    state.organizationId = typeof payload.organizationId !== 'undefined' ? payload.organizationId : '';
  },
  unsetAttributes(state: LoginStateInterface): void {
    state.email = '';
    state.role = '';
    state.organizationId = '';
  },
  setTemporaryEmail(state: LoginStateInterface, payload: { email: string }): void {
    state.temporaryEmail = payload.email;
  },
  unsetTemporaryEmail(state: LoginStateInterface): void {
    state.temporaryEmail = '';
  },
};

export default mutation;
